import { render, staticRenderFns } from "./DeliveryMethodsDialog.vue?vue&type=template&id=1a657ccc&scoped=true"
import script from "./DeliveryMethodsDialog.vue?vue&type=script&lang=js"
export * from "./DeliveryMethodsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a657ccc",
  null
  
)

export default component.exports